import React from "react";
import { useNavigate } from "react-router-dom";
import { MapPin } from "lucide-react";
import { ProductImage } from "@/components/ProductImage";
import { useLang } from "@/context/LanguageContext";
import { categoryLabel, unitLabel, formatPrice } from "@/lib/constants";
import { CompactRating } from "@/components/Reviews";
import { REVIEWS } from "@/constants/testIds";

export const ProductCard = ({ product }) => {
  const navigate = useNavigate();
  const { lang, t } = useLang();

  return (
    <button
      data-testid={`product-card-${product.id}`}
      onClick={() => navigate(`/product/${product.id}`)}
      className="group flex flex-col text-left bg-white rounded-xl border border-[#E5E7EB] overflow-hidden shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200"
    >
      <div className="relative aspect-square w-full overflow-hidden">
        <ProductImage
          images={product.images}
          seed={product.id}
          alt={product.title}
          className="w-full h-full group-hover:scale-105 transition-transform duration-300"
        />
        <span className="absolute top-2 left-2 text-[11px] font-medium px-2 py-0.5 rounded-full bg-white/90 text-[#123A2C]">
          {categoryLabel(product.category, lang)}
        </span>
      </div>
      <div className="p-3 flex flex-col gap-1">
        <h3 className="text-sm sm:text-base font-semibold text-[#14251F] line-clamp-1">
          {product.title}
        </h3>
        <div className="text-base sm:text-lg font-bold text-[#123A2C]">
          {t("common.rs")} {formatPrice(product.price, lang)}
          <span className="text-xs font-normal text-[#9A9E97]"> / {unitLabel(product.unit, lang)}</span>
        </div>
        <CompactRating average={product.rating_avg} count={product.rating_count} testId={`${REVIEWS.cardRating}-${product.id}`} />
        <div className="flex items-center gap-1 text-[#6B7280] text-xs mt-0.5">
          <MapPin className="w-3.5 h-3.5" />
          <span>{product.district}</span>
        </div>
      </div>
    </button>
  );
};
